import { render, staticRenderFns } from "./snsWordCloud.vue?vue&type=template&id=1b07d310&scoped=true"
import script from "./snsWordCloud.vue?vue&type=script&lang=js"
export * from "./snsWordCloud.vue?vue&type=script&lang=js"
import style0 from "./snsWordCloud.vue?vue&type=style&index=0&id=1b07d310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b07d310",
  null
  
)

export default component.exports